import React, { useState, useEffect } from 'react';
import { Menu, MenuItem, Avatar, IconButton, Typography, Divider, Box, Backdrop, } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { esignIcons } from '../Esign/icons';
import { clearUploadedDocument, toggleFullView } from "../../store/reducers/uploadDocumentSlice";
import { logout } from '../../store/reducers/authReducer';
import axiosInstance from '../../services/axiosInstance';
import Loader from '../Loader';
import Cookies from "js-cookie";
import NotificationsUI from './NotificationsUI';
import { dashboard } from "../../store/reducers/pdfeditor/dashboardSlice";
import { useLogger } from '../../hooks/useLogger';

export default function ProfileMenu() {
    const logEvent = useLogger();
    const dispatch = useDispatch();
    const { profileData } = useSelector((state) => state.profile);
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const open = Boolean(anchorEl);
    const { data = {}, status } = useSelector((state) => state.dashboard);
    const [allCraditData, setAllCraditData] = useState([]);
    const [loader, setLoader] = useState(false);

    const channelName = "logout_channel";
    const logoutChannel = new BroadcastChannel(channelName);

    useEffect(() => {
        if (data.status) {
            setAllCraditData(data.credits || {});
        }
    }, [data.status]);

    const handleClick = (event) => {
        logEvent('Click', 'open profile menu in header', 'header');
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        logEvent('Click', 'close profile menu in header', 'header');
        setAnchorEl(null);
    };

    const logoutUserCB = () => {
        dispatch(clearUploadedDocument());
        dispatch(toggleFullView());
        dispatch(logout());
        localStorage.clear();
        sessionStorage.clear();
        clearCookies();
        logoutChannel.postMessage("logout");
    }

    const clearCookies = () => {
        const cookies = document.cookie.split(";");
        for (let cookie of cookies) {
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        }
    };

    const handleLogout = async () => {
        logEvent('Click', 'Click on logout in profile menubar', 'header');
        try {
            setLoader(true);
            const response = await axiosInstance.post(`/EsignServices/LogOut`);
            // if (response.data.status === true) {
            //     dispatch(clearUploadedDocument());
            //     dispatch(toggleFullView());
            //     dispatch(logout());
            //     localStorage.clear();
            //     sessionStorage.clear();
            //     clearCookies();
            //     logoutChannel.postMessage("logout");
            // }
            logoutUserCB()
        } catch (error) {
            console.error("Logout Error:", error);
            logoutUserCB()
        }
    };

    logoutChannel.onmessage = (event) => {
        if (event.data === "logout") {
            window.location.replace(`${process.env.PUBLIC_URL}/login`);
        }
    };

    const getInitials = (name) => {
        if (!name) return "";
        const words = name.trim().split(" ");
        return words.length > 1 
          ? `${words[0][0]}${words[1][0]}`.toUpperCase() 
          : `${words[0][0]}`.toUpperCase();  
    };

    useEffect(() => {
        const handleFocus = () => dispatch(dashboard());
        window.addEventListener("focus", handleFocus);
        return () => window.removeEventListener("focus", handleFocus);
      }, []);
      

    return (
        <>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", gap: 2 }}>
            
            {/* <Box sx={{ height: 40, backgroundColor: "#FFF5E9", display: "flex", alignItems: "center", gap: 1, padding: "0 12px", borderRadius: "8px", cursor: "pointer" }} onClick={() => {logEvent('Click', 'Click on credits in header', 'header'); navigate('/credits')}} >
                <img src={`${process.env.PUBLIC_URL}/images/credit.png`} alt="Credit" style={{ width: 21, height: 21 }} />
                <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#000000" }}>{allCraditData?.credit_left_integer || 0} Credits</Typography>
            </Box> */}
            <NotificationsUI/>
            <IconButton onClick={handleClick} sx={{ p: 0, backgroundColor: 'transparent', "&:hover": { backgroundColor: "transparent !important", }, "&.Mui-focusVisible": { backgroundColor: "transparent", }, "&.Mui-selected": { backgroundColor: "transparent", }, "&.Mui-selected:hover": { backgroundColor: "transparent",} }}>
                <Avatar sx={{ width: 44, height: 44, bgcolor: "#F1D4FF", color: "#A73ED7", fontWeight: "bold", fontSize: 16 }}>
                    {getInitials(profileData?.company_name)}
                </Avatar>
                <Typography sx={{ ml: 1, fontWeight: 600, fontSize: "16px", display: "flex", alignItems: "center", justifyContent: "space-between", color: "#1D1D1D", gap:2 }}>{profileData.company_name}{esignIcons.profileShowIcon}</Typography>
            </IconButton>
            <Backdrop open={open} onClick={handleClose} sx={{ zIndex: 999, color: '#fff', backgroundColor: "rgba(0,0,0,0.1)" }} />
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{ mt: 1, zIndex: 9999 }}
                PaperProps={{
                    sx: { minWidth: 297, borderRadius: "12px 0 12px 12px", "& ul": { p: 0 }, boxShadow: "none" },
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', p: 2, gap: "15px"}}>
                    <Avatar sx={{ width: 52, height: 52, bgcolor: "#F1D4FF", color: "#A73ED7", fontWeight: "bold", fontSize: 16 }}>
                        {getInitials(profileData?.company_name)}
                    </Avatar>
                    <Box>
                        <Typography sx={{ fontWeight: 600 }}>{profileData.company_name}</Typography>
                        {/* <Box sx={{ width: 140, height: 30, backgroundColor: "#FFF5E9", display: "flex", alignItems: "center", gap: 1, padding: "4px 9px", borderRadius: "8px", mt: "11px", cursor: "pointer" }} onClick={() => {logEvent('Click', 'Click on credits in profile menubar', 'header'); navigate('/credits')}}>
                            <img src={`${process.env.PUBLIC_URL}/images/credit.png`} alt="Credit" style={{ width: 21, height: 21 }} />
                            <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#000000" }}>{allCraditData?.credit_left_integer || 0} Credits</Typography>
                        </Box> */}
                        {/* <Typography variant="body2" color="textSecondary">{profileData.admin_type && profileData.admin_type.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}</Typography> */}
                    </Box>
                </Box>
                <Divider sx={{ m: 0, }}/>
                <Box sx={{padding: "5px 0" }}>
                    <Box sx={{ height: 85, background: "linear-gradient(93.93deg, rgba(24, 92, 183, 0.06) 30.05%, rgba(205, 48, 77, 0.06) 95.93%)", borderRadius: "8px", margin: "15px 24px 5px 24px", cursor: "pointer" }} onClick={() => {logEvent('Click', 'Click on credits in profile menubar', 'header'); navigate('/credits'); handleClose();}}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignContent: "center", p: "10px", }}>
                            <Box sx={{ display: "flex", gap: "7px", }}>
                                <img src={`${process.env.PUBLIC_URL}/images/credit.png`} alt="Credit" style={{ width: 17, height: 17 }} />
                                <Typography sx={{ fontWeight: 600, fontSize: "13px", color: "#1D1D1D", lineHeight: "20px",}}>Credits
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ background: "#ffffff", height: "43px", display: "flex", justifyContent: "space-between", alignItems: "center", borderRadius: "0 0 7px 7px", p: "10px", margin: "1px" }}>
                            <Box sx={{ display:"flex", alignItems: "center", gap: "8px", }}>
                                <img src={`${process.env.PUBLIC_URL}/images/aadhaar-sign.svg`} alt="esignIcon" style={{ height: 28 }} />
                                <Box sx={{ textAlign: "left" }}>
                                    <Typography sx={{ fontWeight: 400, fontSize: "10px", color: "#222B38CC", lineHeight: "20px" }}>Aadhaar eSign</Typography>
                                    <Typography sx={{ fontWeight: 600, fontSize: "16px", color: "#1D1D1D" }}>{allCraditData?.aadhaar_credits?.credit_left_integer || 0} </Typography>
                                </Box>
                            </Box>

                            <Box sx={{ display:"flex", alignItems: "center", gap: "8px", }}>
                                <img src={`${process.env.PUBLIC_URL}/images/digital-sign.svg`} alt="esignIcon" style={{ height: 28 }} />
                                <Box sx={{ textAlign: "left" }}>
                                    <Typography sx={{ fontWeight: 400, fontSize: "10px", color: "#222B38CC", lineHeight: "20px" }}>Digital Sign</Typography>
                                    <Typography sx={{ fontWeight: 600, fontSize: "16px", color: "#1D1D1D" }}>{allCraditData?.digital_credits?.credit_left_integer || 0} </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <MenuItem component={Link} to="/my-profile" sx={{ fontSize: "16px", fontWeight: "500", color: "#232323", gap: 2, padding: "15px 24px" }} onClick={handleClose}>
                        {esignIcons.profileIcon}
                        My Profile
                    </MenuItem>
                    <MenuItem component={Link} to="/change-password" sx={{ fontSize: "16px", fontWeight: "500", color: "#232323", gap: 2, padding: "15px 24px" }} onClick={handleClose}>
                        {esignIcons.PasswordIcon}
                        Change Password
                    </MenuItem>
                    <MenuItem component={Link} to="/help-support" sx={{ fontSize: "16px", fontWeight: "500", color: "#232323", gap: 2, padding: "15px 24px" }} onClick={handleClose}>
                        {esignIcons.HelpSupportIcon}
                        Help & Support
                    </MenuItem>
                </Box>
                <Divider sx={{ margin: "0 !important" }}/>

                {/* Logout Option */}
                <MenuItem sx={{ fontSize: "16px", fontWeight: "500", color: "#F8363A", gap: 1, justifyContent: "center", padding: "16px 0" }} onClick={handleLogout}>
                    {esignIcons.logoutIcon}
                    Log out
                </MenuItem>
            </Menu>
        </Box>
        {loader && <Loader />}
        </>
    );
}
